export const colors = {
  dustyRose: '#CFA9A9',    // Accent, buttons, links
  inkBlack: '#1A1A1A',     // Text, logo, primary nav
  boneWhite: '#F7F4F1',    // Background
  coolTaupe: '#9B8D8B',    // Secondary text, icons
  paleMauve: '#E9D6DA',    // Highlights, subtle backgrounds
  white: '#FFFFFF',
  lightGray: '#F8F9FA',
  mediumGray: '#666666',
  darkGray: '#333333',
  gradient: {
    primary: 'linear-gradient(135deg, #1A1A1A 0%, #CFA9A9 100%)',
    secondary: 'linear-gradient(135deg, #CFA9A9 0%, #9B8D8B 100%)',
    accent: 'linear-gradient(135deg, #E9D6DA 0%, #CFA9A9 100%)'
  }
};

export const fonts = {
  heading: "'Playfair Display', serif",
  body: "'Inter', sans-serif"
};

export const spacing = {
  xs: '0.5rem',
  sm: '1rem',
  md: '1.5rem',
  lg: '2rem',
  xl: '3rem',
  xxl: '5rem'
};

export const borderRadius = {
  sm: '5px',
  md: '10px',
  lg: '25px',
  xl: '50px'
};

export const shadows = {
  sm: '0 2px 4px rgba(0, 0, 0, 0.1)',
  md: '0 5px 15px rgba(0, 0, 0, 0.1)',
  lg: '0 10px 20px rgba(0, 0, 0, 0.2)'
};

export const transitions = {
  fast: '0.2s ease',
  normal: '0.3s ease',
  slow: '0.5s ease'
};

// Common styled components for consistent branding
export const commonStyles = {
  button: {
    primary: `
      background: ${colors.dustyRose};
      color: white;
      padding: 1rem 2rem;
      border-radius: ${borderRadius.lg};
      text-decoration: none;
      font-weight: bold;
      font-family: ${fonts.body};
      transition: ${transitions.normal};
      border: none;
      cursor: pointer;
      
      &:hover {
        background: ${colors.coolTaupe};
        transform: translateY(-2px);
        box-shadow: ${shadows.lg};
      }
    `,
    secondary: `
      background: white;
      color: ${colors.inkBlack};
      padding: 1rem 2rem;
      border-radius: ${borderRadius.lg};
      text-decoration: none;
      font-weight: bold;
      font-family: ${fonts.body};
      transition: ${transitions.normal};
      border: 2px solid ${colors.dustyRose};
      cursor: pointer;
      
      &:hover {
        background: ${colors.dustyRose};
        color: white;
        transform: translateY(-2px);
      }
    `
  },
  heading: {
    h1: `
      font-family: ${fonts.heading};
      font-weight: 600;
      color: ${colors.inkBlack};
      line-height: 1.2;
    `,
    h2: `
      font-family: ${fonts.heading};
      font-weight: 600;
      color: ${colors.inkBlack};
      line-height: 1.3;
    `,
    h3: `
      font-family: ${fonts.heading};
      font-weight: 500;
      color: ${colors.inkBlack};
      line-height: 1.4;
    `
  },
  text: {
    body: `
      font-family: ${fonts.body};
      color: ${colors.coolTaupe};
      line-height: 1.6;
    `,
    lead: `
      font-family: ${fonts.body};
      color: ${colors.inkBlack};
      line-height: 1.8;
      font-size: 1.1rem;
    `
  },
  section: {
    light: `
      background: ${colors.boneWhite};
      padding: ${spacing.xxl} ${spacing.lg};
    `,
    accent: `
      background: ${colors.paleMauve};
      padding: ${spacing.xxl} ${spacing.lg};
    `
  }
}; 